import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  downloadSuccess,
  downloadFailure,
  assetTypes,
  updateFilters,
  fetchSuccess,
  fetchFailure,
} from "../actions/asset_old";
import {
  fectchOrgLocEndPoint,
  fetchLocationEndPoint,
  fetchv1DeviceDetailsEndPoint,
  fetchOrganizationEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
import getAddressfromLatLong from "../../global/utility/getAddressfromLatLong";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
dayjs.extend(customParseFormat);
dayjs.extend(utc);

function* downloadSaga(action) {
  try {
    const response = yield call(apiDownload, action.filter);
    if (action.payload === "assetList")
      JSONToCSVDownload(assetCSVFormat(response), "assetList_download.csv");
    yield put(downloadSuccess([...response]));
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}
const dateFormatGMTToLocalDateTimeFormat = (dateString) => {
  if (!dateString) return "-";
  const parsedDate = dayjs.utc(dateString, "MMM D YYYY HH:mm:ss");
  if (parsedDate.isValid()) {
    return parsedDate.local().format("MM-DD-YYYY HH:mm:ss");
  }
  const fallbackDate = new Date(dateString);
  if (!isNaN(fallbackDate)) {
    return fallbackDate.toLocaleString();
  }
  return "-";
};

function* fetchAssetSaga(action) {
  const filters = action.payload;

  try {
    yield put(updateFilters(filters));
    let deviceResponses;

    if (filters.isLoaded) {
      deviceResponses = yield all([call(fetchAssetAPI, filters)]);
    } else {
      deviceResponses = yield all([
        call(fetchAssetAPI, filters),
        call(fetchLocationAPI),
        call(fetchOrganizationAPI),
      ]);
    }

    if (filters.isLoaded) {
      yield put(
        fetchSuccess(
          filters.isLoaded
            ? { devices: deviceResponses[0] }
            : {
                devices: deviceResponses[0],
                locations: [],
                organizations: [],
              }
        )
      );
    } else {
      const uniqueLocations = [];
      const uniqueOrganization = [];
      
      if (deviceResponses[2]?.length > 0 && Array.isArray(deviceResponses[2])) {
        deviceResponses[2].forEach((device, index) => {
          if (device?.tags && device?.tags[0]?.org_name) {
            const isOrgUnique =
              uniqueOrganization.filter(
                (uorg) => uorg.value === device?.tags[0]?.org_name
              ).length === 0;
            if (isOrgUnique) {
              uniqueOrganization.push({
                id: device?.tags[0]?.orgId,
                value: device?.tags[0]?.org_name,
              });
            }
          }
          if (device?.tags && device?.tags[0]?.name) {
            const isLocationUnique =
              uniqueLocations.filter(
                (uorg) => uorg.value === device?.tags[0]?.name
              ).length === 0;
            if (isLocationUnique) {
              uniqueLocations.push({
                id: device?.id,
                value: device?.tags[0]?.name,
              });
            }
          }
          if (index === deviceResponses[2].length - 1) {
            uniqueOrganization.push({
              id: "",
              value: "In-Transit",
            });

            uniqueLocations.push({
              id: "",
              value: "In-Transit",
            });
          }
        });
      }

      yield put(
        fetchSuccess(
          filters.isLoaded
            ? { devices: deviceResponses[0] }
            : {
                devices: deviceResponses[0],
                locations:
                  uniqueLocations.length > 0 ? [...uniqueLocations] : [],
                organizations:
                  uniqueOrganization.length > 0 ? [...uniqueOrganization] : [],
              }
        )
      );
    }
  } catch (error) {
    console.log("error", error);
    yield put(fetchFailure(error.message));
  }
}

async function fetchAssetAPI(filters) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    billingaccountid: sessionStorage.getItem("accountId"),
  };

  let selection='';
  const selectionFilters = alarmFilterbyfilters(filters);
  if (selectionFilters.length > 0) {
    selection = selectionFilters.join(" AND ");
  }

  body.filter = {
    $sort: filters.sort,
    $limitnumber: filters.limitnumber,
    $pagenumber: filters.pagenumber,
    $selection: `${selection}`
  }

  const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();
  let devices = [];

  const $selection = [
    "(kind eq 'ts.device.gateway') or (kind eq 'ts.device.tgAssetTracker')",
  ];

  if (filters?.device) {
    $selection.push(`(name LIKE '%${filters?.device}%')`);
  }

  body = {
    accountName: sessionStorage.getItem("accountId"),
  };
  body.filter = {
    $sort: filters.sort,
    $limitnumber: filters.limitnumber,
    $pagenumber: filters.pagenumber,
    $selection: $selection.join(" AND "),
  }
  const gatewayResponse = await fetch(fetchv1DeviceDetailsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });
  const gatewayResult = await gatewayResponse.json();

  if (Array.isArray(result?.devices) && result?.devices.length > 0) {
    for (let index = 0; index < result?.devices.length; index++) {
      let locationAddress = "UNKNOWN";
      let lastupdated = "";
      let devicename = "";
      let parentdeviceid = null;

      if (
        result?.devices[index]?.fields?.location?.latitude &&
        result?.devices[index]?.fields?.location?.longitude
      ) {
        locationAddress = await getAddressfromLatLong(
          result?.devices[index]?.fields?.location?.latitude,
          result?.devices[index]?.fields?.location?.longitude
        );
      }

      if (result?.devices[index]?.lastupdated) {
        lastupdated = dateFormatGMTToLocalDateTimeFormat(
          result?.devices[index]?.lastupdated
        );
      }

      // if (result?.devices[index].serial) {
      //   const matchingGateway = gatewayResult?.devices.find((gatewayDevice) => {
      //     return (
      //       Array.isArray(gatewayDevice?.fields?.ble?.sensorList) &&
      //       gatewayDevice.fields.ble.sensorList.some(
      //         (sensor) =>
      //           sensor?.serialNum != null &&
      //           result?.devices[index]?.serial != null &&
      //           String(sensor.serialNum).trim() ===
      //             String(result?.devices[index].serial).trim()
      //       )
      //     );
      //   });

      //   if (matchingGateway) {
      //     devicename = matchingGateway.name;
      //     parentdeviceid = matchingGateway.uid;
      //   }
        

        
      // }

      if (result?.devices[index]?.parentdeviceid) {
        const filteredDevice = gatewayResult?.devices.filter(
          (device) => device.uid === result?.devices[index]?.parentdeviceid
        );

        if (Array.isArray(filteredDevice) && filteredDevice.length > 0) {
          devicename = filteredDevice[0]?.name;
          parentdeviceid = result?.devices[index]?.parentdeviceid
        }
      }

      devices.push({
        ...result?.devices[index],
        locationAddress,
        lastupdated,
        devicename,
        parentdeviceid,
      });

      if (filters?.device) {
        devices = devices.filter((device) => device?.devicename);
      }
    }
  }
  return {
    totalCount: result?.totalCount,
    devices: devices.filter((device) => device?.kind === "ts.device.ble"),
  };
}

function alarmFilterbyfilters(filters) {
  let selectionFilters = [];
  selectionFilters.push(`(kind eq 'ts.device.ble')`);

  if (filters.assetType.length > 0) {
    const assetTypeFilters = filters.assetType.map(
      (dev) => `($/customdata/assetType LIKE '${dev}')`
    );
    const assetTypeQuery = assetTypeFilters.join(" OR ");
    selectionFilters.push(
      assetTypeFilters.length > 1 ? `(${assetTypeQuery})` : assetTypeQuery
    );
  }

  if (filters.assetStatus.length > 0) {
    const assetStatusFilters = filters.assetStatus.map(
      (dev) => `($/customdata/assetStatus LIKE '${dev}')`
    );
    const assetStatusQuery = assetStatusFilters.join(" OR ");
    selectionFilters.push(
      assetStatusFilters.length > 1 ? `(${assetStatusQuery})` : assetStatusQuery
    );
  }

  if (filters.assetName) {
    selectionFilters.push(`(name LIKE '%${filters.assetName}%')`);
  }

  if (filters.organization.length > 0) {
    const orgFilters = filters.organization.map(
      (org) => `($/customdata/organizationName LIKE '${org}')`
    );
    const orgQuery = orgFilters.join(" OR ");
    selectionFilters.push(orgFilters.length > 1 ? `(${orgQuery})` : orgQuery);
  }

  if (filters.location.length > 0) {
    const locFilters = filters.location.map(
      (loc) => `($/customdata/locationName LIKE '${loc}')`
    );
    const locQuery = locFilters.join(" OR ");
    selectionFilters.push(locFilters.length > 1 ? `(${locQuery})` : locQuery);
  }

  if (filters.lifeCycleStatus.length > 0) {
    const lifeCycleStatusFilters = filters.lifeCycleStatus.map(
      (loc) => `($/customdata/lifeCycleStatus LIKE '${loc}')`
    );
    const lifeCycleQuery = lifeCycleStatusFilters.join(" OR ");
    selectionFilters.push(
      lifeCycleStatusFilters.length > 1 ? `(${lifeCycleQuery})` : lifeCycleQuery
    );
  }
  if (filters.productiveStatus.length > 0) {
    const productiveStatusFilters = filters.productiveStatus.map(
      (loc) => `($/customdata/productiveStatus LIKE '${loc}')`
    );
    const productiveStatusQuery = productiveStatusFilters.join(" OR ");
    selectionFilters.push(
      productiveStatusFilters.length > 1
        ? `(${productiveStatusQuery})`
        : productiveStatusQuery
    );
  }
  if (filters.idleStatus.length > 0) {
    const idleStatusFilters = filters.idleStatus.map(
      (loc) => `($/customdata/assetStatus LIKE '${loc}')`
    );
    const idleStatusQuery = idleStatusFilters.join(" OR ");
    selectionFilters.push(
      idleStatusFilters.length > 1 ? `(${idleStatusQuery})` : idleStatusQuery
    );
  }
  if (filters.lostStatus.length > 0) {
    const lostStatusFilters = filters.lostStatus.map(
      (loc) => `($/customdata/assetStatus LIKE '${loc}')`
    );
    const lostStatusQuery = lostStatusFilters.join(" OR ");
    selectionFilters.push(
      lostStatusFilters.length > 1 ? `(${lostStatusQuery})` : lostStatusQuery
    );
  }
  return selectionFilters;
}

async function fetchOrganizationAPI() {
  const locResponse = await fetchLocationAPI();
  const response = await fetch(fetchOrganizationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const orgs = await response.json();
  const countMap = {};

  locResponse?.locations.forEach((siteItem) => {
    const orgId = siteItem.tags?.[0]?.orgId;
    if (orgId) {
      countMap[orgId] = (countMap[orgId] || 0) + 1;
    }
  });

  orgs?.organizations.forEach((orgItem) => {
    const orgId = orgItem.id;
    const count = countMap[orgId] || 0;
    orgItem.locationcount = (orgItem.count || 0) + count;
  });

  return orgs;
}

async function fetchLocationAPI() {
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  return response.json();
}

const assetCSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    name: json.name,
    id: json.uid,
    creationDate: json.createdon,
    lastUpdated: json.lastupdated,
    assetType: json.customdata.assetType,
    activeStatus: json.customdata.activeStatus,
    organizationId: json.customdata?.orgId,
    locationId: json.customdata?.locId,
    organizationName: json.customdata?.organizationName,
    locationName: json.customdata?.locationName,
    lastKnownGps:
      json.fields?.location?.type === "gps"
        ? `${json.fields?.location?.latitude}, ${json.fields?.location?.longitude}`
        : "",
    deviceType: json.customdata?.deviceType,
    DeviceRecipe: json.customdata?.deviceType,
    lostStatus: "",
    locationArrivalTime: json.customdata?.arrivedLocationTimestamp,
    idleStatus: json.customdata?.healthStatus,
    lifeCycleStatus: json.customdata?.lifeCycleStatus,
    productiveStatus: json.customdata?.productiveStatus,
    lastLocationId: "",
    lastLocationName: "",
    lastReportedAt: "",
  }));
};

function apiDownload(filter) {
  delete filter["$limitnumber"];
  delete filter["$pagenumber"];
  return fetch(fectchOrgLocEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify(filter),
  }).then((response) => response.json());
}

export function* FetchAssetSaga() {
  yield takeLatest(assetTypes.FETCH_REQUEST, fetchAssetSaga);
}

export function* AssetsDownloadSaga() {
  yield takeLatest(assetTypes.DOWNLOAD_REQUEST, downloadSaga);
}
